module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "v5-x-checklist"
  }, _vm._l((_vm.options), function(item, index) {
    return _c('li', {
      key: item.id,
      staticClass: "v5-x-checklist-item"
    }, [_c('label', {
      attrs: {
        "for": ("v5-x-checklist-" + _vm.uuid + "-" + index)
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.currentValue),
        expression: "currentValue"
      }],
      staticClass: "v5-x-checklist-checkbox",
      attrs: {
        "type": "checkbox",
        "name": ("v5-x-checklist-" + _vm.uuid),
        "id": ("v5-x-checklist-" + _vm.uuid + "-" + index),
        "disabled": _vm.isDisabled(item)
      },
      domProps: {
        "value": item.id,
        "checked": Array.isArray(_vm.currentValue) ? _vm._i(_vm.currentValue, item.id) > -1 : (_vm.currentValue)
      },
      on: {
        "change": [function($event) {
          var $$a = _vm.currentValue,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = item.id,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.currentValue = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.currentValue = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.currentValue = $$c
          }
        }, function($event) {
          return _vm.change(item)
        }]
      }
    }), _vm._v(" "), _vm._t("default", null, {
      "props": item
    })], 2)])
  }), 0)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1ad4743e","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/@58fe/v5/src/components/x-checklist/index.vue
// module id = 335
// module chunks = 0